module.exports = __webpack_public_path__ + "img/MTABAPPPROTOCOL.ae1e78a7.svg";